import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../redux/slices/snackbar";
import { API_BASE_URL } from "../../../../../config";

const NuovoBot = ({ open, setOpen, codiceServizio, codiceScope, setRows }) => {
  const theme = useTheme();
  const [bot, setBot] = useState("");
  const [stato, setStato] = useState("");
  const [statoCodice, setStatoCodice] = useState();
  const [nameError, setNameError] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    setStato("");
    setBot("");
    setStatoCodice(null);
  };

  const handleChangeBot = (e) => {
    setBot(e.target.value);
    if (e.target.validity.valid) {
      setNameError(false);
    } else {
      setNameError(true);
    }
  };

  const handleClickStato = (s) => {
    setStatoCodice(s);
  };

  const handleChangeStato = (e) => {
    setStato(e.target.value);
  };

  const handleCrea = () => {
    if (!nameError) {
      servicesNewUpdate({
        scope: codiceScope,
        codice: codiceServizio,
        idStato: statoCodice,
        nome: bot,
      });
      setOpen(false);
      // Fetch updated data after successful creation
      servicesGetDetails({
        scope: codiceScope,
        codice: codiceServizio,
      });
    } else {
      dispatch(
        showSnackbar({
          message: "Nome bot non valido! Usa solo lettere e numeri.",
          severity: "error",
        })
      );
    }
  };

  useEffect(() => {
    servicesGetDetails({
      scope: codiceScope,
      codice: codiceServizio,
    });
  }, [codiceScope, codiceServizio]);

  async function servicesGetDetails(data) {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: data,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/servicesGetDetails`,
        requestOptions
      );

      const responseData = await response.json();

      const info = responseData.data.info;
      setRows(info);
    } catch (error) {
      return error;
    }
  }

  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message: message, severity: severity }));
  };

  async function servicesNewUpdate(data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: data,
          action: "newBot",
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/servicesNewUpdate`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
      } else {
        handleSnackbar(responseData.message, "error");
      }
    } catch (error) {
      return error;
    }
  }

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>Crea nuovo bot</DialogTitle>
      <DialogContent>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <FormControl
            sx={{ mt: 2 }}
            m={2}
            style={{ minWidth: 120 }}
            size="small"
          >
            <TextField
              size="small"
              label="Bot"
              onChange={handleChangeBot}
              inputProps={{
                pattern: "^[a-zA-Z0-9_]{3,30}$",
              }}
              error={nameError}
              helperText={nameError ? "Min 3, solo lettere e numeri" : ""}
            />
          </FormControl>
          <FormControl m={2} style={{ minWidth: 120 }} size="small">
            <InputLabel id="stato">Stato</InputLabel>
            <Select
              labelId="stato"
              id="stato"
              label="Stato"
              value={stato}
              onChange={handleChangeStato}
              size="small"
            >
              <MenuItem
                onClick={() => handleClickStato(1)}
                sx={{ height: 30 }}
                value="Attivo"
              >
                Attivo
              </MenuItem>
              <MenuItem
                onClick={() => handleClickStato(0)}
                sx={{ height: 30 }}
                value="Non Attivo"
              >
                Non Attivo
              </MenuItem>
            </Select>
          </FormControl>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          sx={{ marginRight: "8px" }}
        >
          Chiudi
        </Button>
        <Button
          onClick={handleCrea}
          variant="contained"
          sx={{ marginRight: "8px" }}
        >
          Crea
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NuovoBot;
